import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import Button from '@hfe/max-button';
import './index.scss';
function ModalCityItem(props) {
    const { onSelectCity, cardGroupInfoVO } = props;
    const { name, iconUrl } = cardGroupInfoVO ?? {};
    return <View className="modal-city-item__outer-wrapper">
      <Image source={{
        uri: iconUrl || ''
    }} className="modal-city-item__background" resizeMode="cover"/>
      <View className="modal-city-item__inner-wrapper">
        <Text className="modal-city-item__city-name" numberOfLines={1}>
          {name}
        </Text>
        <Button className="modal-city-item__button" onPress={() => {
        onSelectCity(cardGroupInfoVO);
    }}>
          <Text className="modal-city-item__button-text">去看看</Text>
        </Button>
      </View>
    </View>;
}
export default memo(ModalCityItem);
